import React, { memo } from 'react';
import { Modal, View } from 'react-native';

export const ModalContainer = memo(({ children, style, ...rest }) => {
  return (
    <Modal animationType="fade" transparent {...rest}>
      <View style={[{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)' }, style]}>
        {children}
      </View>
    </Modal>
  );
});
